const moment = require("moment")
export const generateLinkViews = (days, data) => {
  const startDate = moment().subtract(days, "days").format("MM-DD-YYYY")
  const endDate = moment()

  const countOfDays = endDate.diff(startDate, "days")

  let preparedData = []

  for (let i = 0; i <= countOfDays; i++) {
    const current = moment(startDate).add(i, "day").format("MM-DD-YYYY")
    let values = {}
    for (const index in data) {
      console.log("INDEX", index)
      const v = data[index]?.views?.find(x => x?.date === current)
      values[index] = v?.total_views || 0
    }

    preparedData.push({ date: current, ...values })
  }

  return preparedData
}
